export default {
    messages: {
        user_invited: 'Приглашение отправлено на почту пользователя',
    },
    buttons: {
        invite: 'Пригласить',
        invite_company_user: 'Пригласить пользователя компании',
        change_role: 'Изменить роль',
    },
    fields: {
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
    },
    errors: {
        user_not_found: 'Пользователь не найден',
        company_not_found: 'Компания не найдена',
        user_already_part_of_the_company: 'Пользователь уже является частью компании',
    },
}
